import { useState } from "react";
import { Collapse, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { PlanExerciseItem, PlanSuperSetItem } from "./PrintablePlanExercise";

export default function WorkoutCard({
  workout,
  index,
  getExerciseName,
  findById,
  defaultExpanded = false,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded || index === 0);
  const isRest = workout?.isRestSplit ?? false;
  const exercises = workout?.exercises ?? [];
  const headerAlt = index % 2 === 1 ? " pp-workout-header--alt" : "";

  if (isRest) {
    return (
      <section className="pp-workout pp-workout--rest">
        <div className="pp-workout-header">
          <div className="pp-workout-header-main">
            <span className="pp-workout-day">Day {index + 1}</span>
            <div>
              <h3 className="pp-workout-name">{workout?.name || "Rest Day"}</h3>
            </div>
          </div>
        </div>
        {workout?.description ? (
          <div className="pp-workout-body">
            <p className="pp-workout-description">{workout.description}</p>
          </div>
        ) : null}
      </section>
    );
  }

  const toggleExpanded = () => setExpanded((prev) => !prev);

  return (
    <section className="pp-workout">
      <button
        type="button"
        className={`pp-workout-header pp-workout-header--interactive${headerAlt}`}
        onClick={toggleExpanded}
        aria-expanded={expanded}
      >
        <div className="pp-workout-header-main">
          <span className="pp-workout-day">Day {index + 1}</span>
          <div>
            <h3 className="pp-workout-name">{workout?.name || `Workout ${index + 1}`}</h3>
            <p className="pp-workout-count">
              {exercises.length} exercise{exercises.length !== 1 ? "s" : ""}
            </p>
          </div>
        </div>
        <IconButton
          className="pp-workout-toggle"
          size="small"
          aria-label={expanded ? "Collapse workout" : "Expand workout"}
          onClick={(event) => {
            event.stopPropagation();
            toggleExpanded();
          }}
        >
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </button>
      <Collapse in={expanded}>
        <div className="pp-workout-body">
          {workout?.description ? (
            <p className="pp-workout-description">{workout.description}</p>
          ) : null}
          <div className="pp-exercise-list">
            {exercises.map((ex, exIdx) =>
              ex?.type === "super_set" ? (
                <PlanSuperSetItem
                  key={ex.id ?? exIdx}
                  exercise={ex}
                  index={exIdx}
                  findById={findById}
                  getExerciseName={getExerciseName}
                  linkExerciseNames
                />
              ) : (
                <PlanExerciseItem
                  key={ex.id ?? exIdx}
                  exercise={ex}
                  index={exIdx}
                  findById={findById}
                  getExerciseName={getExerciseName}
                  linkExerciseNames
                />
              )
            )}
          </div>
        </div>
      </Collapse>
    </section>
  );
}
